// extracted by mini-css-extract-plugin
export var actions = "_1d-0";
export var actionsContainer = "_1d-6";
export var border = "_1d-1";
export var childFullHeight = "_1d-d";
export var collapse = "_1d-2";
export var content = "_1d-8";
export var contentChild = "_1d-c";
export var fullscreen = "_1d-a";
export var hasLeftRadius = "_1d-i";
export var headerContainer = "_1d-3";
export var headerRow = "_1d-5";
export var hidePadding = "_1d-9";
export var navCollapsedGap = "_1d-j";
export var noScrollX = "_1d-k";
export var noScrollY = "_1d-l";
export var noTopPadding = "_1d-g";
export var optOutTopPadding = "_1d-b";
export var pageMain = "_1d-h";
export var pageOuter = "_1d-e";
export var pagePadding = "_1d-7";
export var profile = "_1d-m";
export var profileContainer = "_1d-n";
export var profileImage = "_1d-o";
export var profileMain = "_1d-p";
export var profileSubtitle = "_1d-r";
export var profileTitle = "_1d-q";
export var showLeftPadding = "_1d-f";
export var tabsWrapper = "_1d-4";
export var title = "_1d-s";